module.exports = __webpack_public_path__ + "img/vol04_character_img01.ee87fcd2.png";